import AbstractEditWidget from "../../../cluetrainer/ui/widgets/AbstractEditWidget";
import jquery from "jquery";
export default class NumberInput extends AbstractEditWidget {
    constructor(min, max) {
        super(jquery(`<input type='number' class='nisl-textinput' min='${min}' max="${max}">`));
        this.min = min;
        this.max = max;
        this.container
            .on("input", () => {
            this.commit(Number(this.container.val()));
        });
    }
    render() {
        this.container.val(this.get());
    }
}
